import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import type { DTOCreateCheckoutResponse } from 'src/apis/dto/DTOSubscription';
import { client } from 'src/utils/api';

const createCheckout = async (productId: string): Promise<DTOCreateCheckoutResponse> => {
  const response = await client.post<DTOCreateCheckoutResponse>(
    `/api/v1/subscriptions/products/${productId}`
  );
  return response.data;
};

type UseCreateCheckoutOptions = Omit<
  UseMutationOptions<DTOCreateCheckoutResponse, Error, string>,
  'mutationFn'
>;

export const useCreateCheckout = (options?: UseCreateCheckoutOptions) =>
  useMutation({ mutationFn: createCheckout, ...options });
